import {
  getFireVideoID,
  IAnnotationDetails,
} from 'components/common/video/annotated-player';
import { UserRole } from 'lib_ts/enums/auth.enums';
import { TrackingDevice } from 'lib_ts/enums/training.enums';
import { IFireEvent } from 'lib_ts/interfaces/i-session-event';
import { ISessionHit } from 'lib_ts/interfaces/session-hits/i-session-hit';
import { first } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { SessionEventsService } from 'services/session-events.service';

// todo: this probably doesn't belong here
export const canFlagDetectionIssue = (
  hit: ISessionHit | undefined,
  role: UserRole | undefined
) =>
  hit?.tracking_device === TrackingDevice.TrajektVision &&
  role === UserRole.admin;

/** annotated (or replay) video for a session hit's fire */
export const useSessionHitVideo = (
  hit: ISessionHit | undefined
): IAnnotationDetails | undefined => {
  const fireID = hit?.fire._id;
  const [fireEvent, setFireEvent] = useState<IFireEvent>();

  useEffect(() => {
    setFireEvent(undefined);

    if (!fireID) {
      return;
    }

    let active = true;

    SessionEventsService.getFireByID(fireID).then((result) => {
      if (active) {
        setFireEvent(result);
      }
    });

    return () => {
      active = false;
    };
  }, [fireID]);

  return useMemo(() => {
    const videoID = getFireVideoID({
      annotated_video_id: hit?.fire.annotated_video_id,
      replay_video_id: hit?.fire.replay_video_id,
    });

    if (!videoID) {
      return undefined;
    }

    const shot = first(fireEvent?.shot);

    return {
      videoID,
      fireID: shot?.fire_id,
      shotID: shot?._id,
      hitterID: hit?.hitter?._id,
    };
  }, [hit?.fire, hit?.hitter?._id, fireEvent]);
};
